import React from "react";
import { connect } from "react-redux";
import { Text, Box, Flex, Button, Input, useClipboard } from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";
const Shortcode = ({ templateId }) => {
	const { hasCopied, onCopy } = useClipboard(templateId);
	return (
		<Box mt="3">
			<Text fontSize="14px" mb="2">
				Shortcode
			</Text>
			<Flex mb={2}>
				<Input backgroundColor="background.disabled" value={templateId} size="sm" isReadOnly />
				<Button
					onClick={onCopy}
					colorScheme="secondary"
					className="btn--secondary"
					size="sm"
					ml={2}
				>
					<CopyIcon mr="2" />
					{hasCopied ? "Copied" : "Copy"}
				</Button>
			</Flex>
		</Box>
	);
};

const mapStateToProps = (state) => {
	const { currentTemplate } = state.templates;
	return {
		templateId: `[fwforms-id=${currentTemplate.id}]`,
	};
};

export default connect(mapStateToProps, null)(Shortcode);
